// extracted by mini-css-extract-plugin
export default {"input":"input__EDlYe","block":"block__QXAEM","native":"native__o--Em","textarea":"textarea__Q5tRP","description":"description__7OL4n","prefix":"prefix__ejeCJ"};